// import React, { useState, useEffect } from 'react';
// import { Box } from '@mui/material';

// const images = [
//   'https://en-media.thebetterindia.com/uploads/2017/10/1-7.png',
//   'https://media.istockphoto.com/id/1192261413/photo/high-court-of-karnataka.jpg?s=170667a&w=0&k=20&c=nuCo4eZWHmxUVUSBmYtoRW82YnnheDya-K0mR7Dt0ys=',
//   'https://th.bing.com/th/id/R.1cc82cc27dc97cf64d81ace32c04821e?rik=4ICGyihR0f0PDQ&riu=http%3a%2f%2fwww.talkativeman.com%2fimg%2fHeritage_Structure_of_Vidhana_Soudha_Bangalore.jpg&ehk=IfsKnHToAAZAcG6U9NfIyRb8URtL5d0RoLLVaMQhANw%3d&risl=&pid=ImgRaw&r=0',
//   'https://cdnbbsr.s3waas.gov.in/s388ef51f0bf911e452e8dbb1d807a81ab/uploads/2021/06/2021062995-768x490.jpg',
// ];

// export default function FullscreenImageSlider() {
//   const [currentIndex, setCurrentIndex] = useState(0);

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
//     }, 5000);

//     return () => clearInterval(interval);
//   }, []);

//   return (
//     <Box
//       component="section"
//       sx={{
//         height: { xs: '30vh', sm: '50vh', md: '70vh' }, // Responsive heights
//         width: '100%',
//         position: 'relative',
//         overflow: 'hidden',
//         mt: 6.5,
//       }}
//     >
//       {images.map((src, index) => (
//         <Box
//           key={index}
//           component="img"
//           src={src}
//           alt={`slide-${index}`}
//           sx={{
//             position: 'absolute',
//             top: 0,
//             left: 0,
//             width: '100%',
//             height: '100%', // Match parent Box height
//             objectFit: 'cover',
//             transition: 'opacity 1s ease-in-out',
//             opacity: index === currentIndex ? 1 : 0,
//             zIndex: index === currentIndex ? 1 : 0,
//           }}
//         />
//       ))}
//     </Box>
//   );
// }



import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';

const images = [
  'https://en-media.thebetterindia.com/uploads/2017/10/1-7.png',
  'https://media.istockphoto.com/id/1192261413/photo/high-court-of-karnataka.jpg?s=170667a&w=0&k=20&c=nuCo4eZWHmxUVUSBmYtoRW82YnnheDya-K0mR7Dt0ys=',
  'https://th.bing.com/th/id/R.1cc82cc27dc97cf64d81ace32c04821e?rik=4ICGyihR0f0PDQ&riu=http%3a%2f%2fwww.talkativeman.com%2fimg%2fHeritage_Structure_of_Vidhana_Soudha_Bangalore.jpg&ehk=IfsKnHToAAZAcG6U9NfIyRb8URtL5d0RoLLVaMQhANw%3d&risl=&pid=ImgRaw&r=0',
  'https://cdnbbsr.s3waas.gov.in/s388ef51f0bf911e452e8dbb1d807a81ab/uploads/2021/06/2021062995-768x490.jpg',
];

export default function FullscreenImageSlider() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsTransitioning(true);
      
      // Start transition
      setTimeout(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
      }, 50);
      
      // End transition
      setTimeout(() => {
        setIsTransitioning(false);
      }, 1000);
      
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const goToSlide = (index) => {
    setIsTransitioning(true);
    setTimeout(() => {
      setCurrentIndex(index);
    }, 50);
    setTimeout(() => {
      setIsTransitioning(false);
    }, 1000);
  };

  return (
    <Box
      component="section"
      sx={{
        height: { xs: '30vh', sm: '50vh', md: '70vh' },
        width: '100%',
        position: 'relative',
        overflow: 'hidden',
        mt: 6.5,
        '&:hover .slide-indicators': {
          opacity: 1,
          transform: 'translateY(0)',
        }
      }}
    >
      {/* Main Slides */}
      {images.map((src, index) => (
        <Box
          key={index}
          component="img"
          src={src}
          alt={`slide-${index}`}
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            transition: 'all 1.2s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
            transform: index === currentIndex ? 'scale(1)' : 'scale(1.1)',
            opacity: index === currentIndex ? 1 : 0,
            zIndex: index === currentIndex ? 2 : 1,
            filter: index === currentIndex ? 'brightness(1)' : 'brightness(0.8)',
            willChange: 'transform, opacity',
          }}
        />
      ))}

      {/* Slide Indicators */}
      <Box
        className="slide-indicators"
        sx={{
          position: 'absolute',
          bottom: 20,
          left: '50%',
          transform: 'translateX(-50%)',
          display: 'flex',
          gap: 1,
          zIndex: 3,
          opacity: 0,
          transition: 'all 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
          transform: 'translateY(20px)',
        }}
      >
        {images.map((_, index) => (
          <Box
            key={index}
            onClick={() => goToSlide(index)}
            sx={{
              width: 12,
              height: 12,
              borderRadius: '50%',
              backgroundColor: index === currentIndex ? 'white' : 'rgba(255,255,255,0.5)',
              cursor: 'pointer',
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              transform: index === currentIndex ? 'scale(1.2)' : 'scale(1)',
              '&:hover': {
                backgroundColor: 'white',
                transform: 'scale(1.3)',
              },
            }}
          />
        ))}
      </Box>

      {/* Progress Bar */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: 3,
          backgroundColor: 'rgba(255,255,255,0.3)',
          zIndex: 3,
        }}
      >
        <Box
          sx={{
            width: '100%',
            height: '100%',
            backgroundColor: 'white',
            transform: isTransitioning ? 'scaleX(1)' : 'scaleX(0)',
            transformOrigin: 'left center',
            transition: 'transform 5s linear',
          }}
        />
      </Box>

      {/* Navigation Arrows */}
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: 0,
          right: 0,
          display: 'flex',
          justifyContent: 'space-between',
          padding: 2,
          zIndex: 3,
          opacity: 0,
          transition: 'opacity 0.3s ease',
          '&:hover': {
            opacity: 1,
          }
        }}
      >
        <Box
          onClick={() => goToSlide((currentIndex - 1 + images.length) % images.length)}
          sx={{
            width: 40,
            height: 40,
            borderRadius: '50%',
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            '&:hover': {
              backgroundColor: 'rgba(0,0,0,0.8)',
              transform: 'scale(1.1)',
            },
          }}
        >
          <Box
            sx={{
              width: 0,
              height: 0,
              borderTop: '8px solid transparent',
              borderBottom: '8px solid transparent',
              borderRight: '8px solid white',
              marginLeft: 2,
            }}
          />
        </Box>
        
        <Box
          onClick={() => goToSlide((currentIndex + 1) % images.length)}
          sx={{
            width: 40,
            height: 40,
            borderRadius: '50%',
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            '&:hover': {
              backgroundColor: 'rgba(0,0,0,0.8)',
              transform: 'scale(1.1)',
            },
          }}
        >
          <Box
            sx={{
              width: 0,
              height: 0,
              borderTop: '8px solid transparent',
              borderBottom: '8px solid transparent',
              borderLeft: '8px solid white',
              marginRight: 2,
            }}
          />
        </Box>
      </Box>

      {/* Overlay Gradient */}
      <Box
        sx={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          width: '100%',
          height: '30%',
          background: 'linear-gradient(to top, rgba(0,0,0,0.4) 0%, transparent 100%)',
          zIndex: 2,
          pointerEvents: 'none',
        }}
      />
    </Box>
  );
}